// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { SignedDocumentType } from '../../types/signedDocument';
import './DocumentTypeBadge.css';

export type DocumentTypeBadgeProps = Readonly<{
  documentType: SignedDocumentType;
}>;

/**
 * Tiny purple pill for the document type in the Documents list. LoA / CoA map
 * to their workflow label; sealed assessment records are tagged "Assessment";
 * anything manually uploaded is tagged "Upload".
 */
function documentTypeLabel(documentType: SignedDocumentType): string {
  switch (documentType) {
    case 'LOA':
      return 'LoA';
    case 'COA':
      return 'CoA';
    case 'ASSESSMENT':
      return 'Assessment';
    case 'SOS':
      return 'SoS';
    case 'NEW_BUSINESS':
      return 'New Business';
    default:
      return 'Upload';
  }
}

export function DocumentTypeBadge({ documentType }: DocumentTypeBadgeProps) {
  return (
    <span
      className={`document-type-badge document-type-badge--${documentType.toLowerCase()}`}
      data-testid={`document-type-badge-${documentType.toLowerCase()}`}
    >
      {documentTypeLabel(documentType)}
    </span>
  );
}

export default DocumentTypeBadge;
